module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAMCAYAAAC9QufkAAAAAXNSR0IArs4c6QAAAPRJREFUKBWFkbsOAUEUho24JKIRCqHxFF5BqfAA3oFCI1FIhN4DSMQraESrUkhkGy0KiUuBjVCsb8TZTGZXnOTbM+c/lzmZVZE/5nlekpIKpGGulDqgpfDup5WgC/lPYHzQMrAGsTOHCTRBSfOVYAdlozdCPADbXgh6QFaaF9+KB34MdSjCFMKs4F9CtgG60banLRAfpTH6PegH0Q9jW9wWiDeiSXMfwZ8oyR9+FtBZpwVhq5ubuwQ5aZabdazXSUjih+/xf8M3ZGoJluZVxnkUGEgyCzVogwO23RE6EHi8GGucSGyZWoUX3OACDqxgSM0eH7A33rM24R8y6sYAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/img/ic-twitter.png
// module id = 1408
// module chunks = 0